import { LitEntity, html } from '../utility/lit-entity';

class WorkOrderAdminList extends LitEntity {
  static get properties() {
    return {
      workOrders: { type: Array, attribute: false },
    };
  }

  render() {
    return html`
      <ul>${this.workOrders.map(workOrder => this._renderWorkOrder(workOrder))}</ul>
    `;
  }

  _renderWorkOrder(workOrder) {
    const selfHref = workOrder.getLink('self').href;
    return html`
      <li>
        <a href="/work-order-admin/show?workOrderId=${encodeURIComponent(selfHref)}">
          ${workOrder.properties.referenceId}
        </a>
      </li>
    `;
  }

  _entityChanged(entity) {
    super._entityChanged(entity);
    this.workOrders = this.entity?.getSubEntitiesByClass('work-order') || [];
  }
}

customElements.define('work-order-admin-list', WorkOrderAdminList);
